import { render } from "./LoadingCarWheelSpinner.vue?vue&type=template&id=65d37b6e&scoped=true&ts=true"
import script from "./LoadingCarWheelSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingCarWheelSpinner.vue?vue&type=script&lang=ts"

import "./LoadingCarWheelSpinner.vue?vue&type=style&index=0&id=65d37b6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d37b6e"]])

export default __exports__